<template>
  <v-row class="mx-0">
    <v-container
      class="grey lighten-2 the_padding"
      :class="[$vuetify.breakpoint.mdAndUp ? 'px-12' : '']"
      fluid
      :style="{
        backgroundImage:
          'url(' + `${publicPath}images/imagenes/portada.jpg` + ')',
      }"
      style="background-size: cover"
    >
      <v-card color="white">
        <v-row class="my-10">
          <v-col sm="12" md="12" class="px-md-12">
            <form
              action="https://www.adquiramexico.com.mx:443/mExpress/pago/avanzado"
              method="post"
            >
              <input
                id="price_campus"
                type="hidden"
                name="importe"
                value="4000"
              />
              <input type="hidden" name="referencia" id="referencia" />
              <input
                type="hidden"
                name="urlretorno"
                value="https://uvaenlinea.uva.edu.mx/posgrados"
              />
              <input type="hidden" name="idexpress" value="1939" />
              <input type="hidden" name="financiamiento" value="0" />
              <input type="hidden" name="plazos" value />
              <input type="hidden" name="mediospago" value="100000" />
              <v-row class="mx-0" :reverse="$vuetify.breakpoint.smAndDown">
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                  :class="[$vuetify.breakpoint.mdAndUp ? 'px-12 pt-12' : '']"
                >
                  <h1
                    :class="[
                      $vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1',
                    ]"
                    class="font-weight-bold text-uppercase mb-4 text-center"
                  >
                    ¡Inscríbete aquí!
                  </h1>
                  <p class="title text-center pb-2">
                    Te ofrecemos dos opciones para realizar tu inscripción.
                  </p>
                  <div>
                    <p class="title my-3 font-weight-medium">
                      1. Llena el siguiente formulario y da clic en realizar
                      pago.
                    </p>
                    <p class="font-weight-regular">
                      Deberás proporcionar la información de tu tarjeta de
                      crédito o débito. Al finalizar el proceso recibirás un
                      correo con el comprobante de tus datos y pago, una vez que
                      validemos tu pago recibirás tu acceso a la plataforma
                      educativa.
                    </p>
                  </div>
                  <div>
                    <p class="title my-3 font-weight-medium">
                      2. Puedes realizar el pago de tu inscripción en BBVA
                      Bancomer al número de cuenta
                      <v-chip color="primary">
                        <span class="font-weight-bold"
                          >0112275589</span
                        > </v-chip
                      >a nombre de Patronato Cultural Vizcaya AC.
                    </p>
                    <p class="font-weight-regular">
                      Una vez realizado el pago debes enviar una fotografía o
                      digitalización de tu ficha de depósito al correo:
                      informesuvaenlinea@uva.edu.mx o bien al WhatsApp de
                      Vizcaya en línea. Dentro de las siguientes 24 horas
                      recibirás tu clave de acceso a la plataforma educativa.
                    </p>
                  </div>
                </v-col>
                <!--<v-col cols="12">
                  <p>Tarjetas de crédito</p>
                  <v-container fluid>
                    <v-row :align="alignment" :justify="justify">
                      <v-col cols="3" md="1" sm="2">
                        <v-img
                          :src="`${publicPath}images/logos_tajetas/visa.png`"
                          alt
                          height="7vh"
                          contain
                          width="40vw"
                        ></v-img>
                      </v-col>

                      <v-col cols="3" md="1" sm="2">
                        <v-img
                          :src="`${publicPath}images/logos_tajetas/mastercard.png`"
                          alt
                          height="7vh"
                          contain
                          width="40vw"
                        ></v-img>
                      </v-col>

                      <v-col cols="3" md="1" sm="2">
                        <v-img
                          :src="`${publicPath}images/logos_tajetas/aexpress.png`"
                          alt
                          height="7vh"
                          contain
                          width="40vw"
                        ></v-img>
                      </v-col>
                      <v-col cols="3" md="1" sm="2">
                        <v-img
                          :src="`${publicPath}images/logos_tajetas/carnet.png`"
                          alt
                          height="7vh"
                          contain
                          width="40vw"
                        ></v-img>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
                <v-col cols="12">
                  <p>Tarjetas de débito</p>
                  <v-container fluid>
                    <v-row :align="alignment" :justify="justify">
                      <v-col cols="6" md="1" sm="2">
                        <v-img
                          :src="`${publicPath}images/logos_tajetas/bbva.png`"
                          alt
                          height="9vh"
                          contain
                          width="40vw"
                        ></v-img>
                      </v-col>

                      <v-col cols="6" md="1" sm="2">
                        <v-img
                          :src="`${publicPath}images/logos_tajetas/santander.png`"
                          alt
                          height="9vh"
                          contain
                          width="40vw"
                        ></v-img>
                      </v-col>

                      <v-col cols="6" md="1" sm="2">
                        <v-img
                          :src="`${publicPath}images/logos_tajetas/hsbc.png`"
                          alt
                          height="9vh"
                          contain
                          width="40vw"
                        ></v-img>
                      </v-col>
                      <v-col cols="6" md="1" sm="2">
                        <v-img
                          :src="`${publicPath}images/logos_tajetas/scotiabank.png`"
                          alt
                          height="9vh"
                          contain
                          width="40vw"
                        ></v-img>
                      </v-col>
                      <v-col cols="6" md="1" sm="2">
                        <v-img
                          :src="`${publicPath}images/logos_tajetas/inbursa.png`"
                          alt
                          height="9vh"
                          contain
                          width="40vw"
                        ></v-img>
                      </v-col>
                      <v-col cols="6" md="1" sm="2">
                        <v-img
                          :src="`${publicPath}images/logos_tajetas/ixe.png`"
                          alt
                          height="9vh"
                          contain
                          width="40vw"
                        ></v-img>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>-->
                <v-col cols="12" sm="12" md="12">
                  <v-alert
                    border="bottom"
                    colored-border
                    type="info"
                    elevation="2"
                  >
                    Tus pagos se realizan de forma segura con
                    <strong>encriptación de 256 bits</strong>
                  </v-alert>
                </v-col>
              </v-row>
              <v-layout
                :row="$vuetify.breakpoint.mdAndUp"
                :column="$vuetify.breakpoint.smAndDown"
                :reverse="$vuetify.breakpoint.smAndDown"
                class="mx-5"
              >
                <div
                  class="flex-grow-1"
                  v-if="$vuetify.breakpoint.mdAndUp"
                ></div>
                <v-btn rounded large text class="px-10 mb-5" href="/"
                  >Cancelar</v-btn
                >
                <v-btn
                  rounded
                  large
                  color="primary"
                  class="px-10 mb-5"
                  id="pay-button"
                  type="submit"
                  @click="sendpaymentTag()"
                  :disabled="this.enabled"
                  >Realizar pago</v-btn
                >
              </v-layout>
            </form>
          </v-col>
        </v-row>
      </v-card>
      <v-snackbar
        v-model="snackbar.visible"
        :multi-line="false"
        :center="true"
        :bottom="true"
      >
        {{ snackbar.text }}
        <v-btn :color="snackbar.color" text @click="snackbar.visible = false"
          >Cerrar</v-btn
        >
      </v-snackbar>
    </v-container>
  </v-row>
</template>
<style lang="scss" scoped>
.action-img {
  background-size: cover;
}
.action-img-mobile {
  background-size: cover;
  height: 400px;
}
.profile-img {
  background-size: cover;
}
.profile-img-mobile {
  background-size: contain;
  height: 200px;
}
.blue-bg {
  background-color: #111f3c;
}
.the_padding {
  padding-top: 120px;
}
</style>
<script>
import { mapState, mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      enabled: false,
      reference: "",
      alignment: "start",
      justify: "start",
      publicPath: process.env.BASE_URL,
      alwaysShow: false,
      snackbar: {
        text: "",
        color: "red",
        visible: false,
      },
      order: {
        order_id: null,
        token_id: null,
        total: 0,
      },
    };
  },
  computed: {
    ...mapState({
      price: (state) => state.home.price_dip,
    }),
  },
  methods: {
    sendpaymentTag() {
      fbq("track", "InitiateCheckout");
      gtag("event", "conversion", {
        send_to: "AW-739642856/eNLsCKX2_sQBEOib2OAC",
        event_callback: () => {
          console.log("uvaonline-payment-btn");
        },
      });
    },
    generateClientToken() {
      //$("#pay-button").prop("disabled", true);
      OpenPay.token.extractFormAndCreate(
        "paymentForm",
        this.success_callbak,
        this.error_callbak
      );
    },
    success_callbak(response) {
      this.snackbar.text =
        "Su pago esta siendo procesado, le sugerimos no recargar ni cerrar la ventana del navegador.";
      this.snackbar.visible = true;
      this.snackbar.color = "info";
      this.order.token_id = response.data.id;
      this.order.order_id = Math.floor(Math.random() * 10000 + 1);
      var deviceSessionId = OpenPay.deviceData.setup(
        "paymentForm",
        "deviceIdHiddenFieldName"
      );
      //paymentForm.submit()
      let self = this;
      setTimeout(function () {
        self.$router.push("/pago_exitoso");
      }, 1500);
    },
    error_callbak(response) {
      let desc =
        response.data.description != undefined
          ? response.data.description
          : response.message;
      var msg = "";
      switch (response.status) {
        /* ERRORES GENERALES */
        case "1000":
        case "1004":
        case "1005":
          msg = "Servicio no disponible.";
          break;
        /* ERRORES TARJETA */
        case "3001":
        case "3004":
        case "3005":
        case "3007":
          msg = "La tarjeta fue rechazada.";
          break;
        case "3002":
          msg = "La tarjeta ha expirado.";
          break;
        case "3003":
          msg = "La tarjeta no tiene fondos suficientes.";
          break;
        case "3006":
          msg =
            "La operación no esta permitida para este cliente o esta transacción.";
          break;
        case "3008":
          msg = "La tarjeta no es soportada en transacciones en línea.";
          break;
        case "3009":
          msg = "La tarjeta fue reportada como perdida.";
          break;
        case "3010":
          msg = "El banco ha restringido la tarjeta.";
          break;
        case "3011":
          msg =
            "El banco ha solicitado que la tarjeta sea retenida. Contacte al banco.";
          break;
        case "3012":
          msg =
            "Se requiere solicitar al banco autorización para realizar este pago.";
          break;
        default:
          /* Demás errores 400 */
          msg = desc;
          break;
      }
      this.snackbar.text = msg;
      this.snackbar.visible = true;
      //$("#pay-button").prop("disabled", false);
    },
  },
  mounted() {
    this.reference = this.$store.state.referenceStore;
    if (this.reference == "" || this.reference == null) {
      this.enabled = true;
      this.snackbar.text =
        "Algo sucedió mal, redireccionando a la pagina anterior";
      this.snackbar.color = "danger";
      this.snackbar.visible = true;
      setTimeout(() => this.$router.go(-1), 1500);
    } else {
      this.enabled = false;
      document.getElementById("referencia").value = this.reference;
      //aqui falta la línea de asignar el monto de cargo
    }
    setTimeout(
      () => (document.getElementById("price_campus").value = self.price),
      1500
    );
    var self = this;
    OpenPay.setId("mvffrfewxonic3geacog");
    OpenPay.setApiKey("pk_fee3bebf1a654d1084dfc268858e7c2d");
    OpenPay.setSandboxMode(true);
  },
};
</script>